import _ from 'lodash';
import { useEffect } from 'react';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
};

const useEmailsTemplate = () => {
  const { state: { emailsTemplate = initialState }, dispatch } = useGlobalContext(),
    { actions: headerActions } = useHeader();

  const { data, mutate } = useFetch({
    url: 'emails-template/list',
    params: { term: emailsTemplate.term, offset: emailsTemplate.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Modelos de Email',
      count: _.get(data, 'count', 0),
      loading: _.get(emailsTemplate, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, emailsTemplate]);

  const list = (offset = 0, term) => {
    dispatch({ type: 'emailsTemplate', payload: { offset, term } });
  };

  const pageChange = (offset = 0) => {
    dispatch({ type: 'emailsTemplate', payload: { offset } });
  };

  const load = async (data = {}) => {
    try {
      dispatch({ type: 'emailsTemplate', payload: { model: {}, formLoading: true }});
      let model = {};

      if (data.id) {
        const response = await api.get('emails-template/load', { params: { id: data.id } });
        model = response.data;
      }
      dispatch({ type: 'emailsTemplate', payload: { model, formLoading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const remove = async (model, actions) => {
    try {
      dispatch({ type: 'emailsTemplate', payload: { formLoading: true }});

      if (_.get(model, 'id')) {
        await api.delete('emails-template/remove', { params: { id: _.get(model, 'id') } });
      }
      showMessage('success', `Modelo de email removido com sucesso`);
      dispatch({ type: 'emailsTemplate', payload: { formLoading: false } });
      actions.toogleForm && actions.toogleForm();
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const createOrUpdate = async (model, actions) => {
    try {
      dispatch({ type: 'emailsTemplate', payload: { formLoading: true } });

      let editing = !!(model && model.id),
        method = editing ? 'put' : 'post',
        path = editing ? 'update' : 'create';

      await api[method](`emails-template/${path}`, model);
      mutate(data);
      showMessage('success', `Modelo de email ${editing ? 'atualizado' : 'criado'} com sucesso`);
      actions.toogleForm && actions.toogleForm();
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const listPlaces = async (term, callback) => {
    try {
      const response = await api.get(`emails-template/list-places`, { params: { term } });
      callback(response.data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  return {
    state: {
      ...emailsTemplate,
      data: data || {},
      loading: !data,
    },
    actions: {
      pageChange,
      load,
      list,
      remove,
      createOrUpdate,
      listPlaces,
    },
  };
};

const failure = (error, dispatch) => {
  dispatch({ type: 'emailsTemplate', payload: { loading: false, formLoading: false }});
  showMessage('error', error);
};

export default useEmailsTemplate;
